import { render, staticRenderFns } from "./zeroRows.vue?vue&type=template&id=23d2fa8e&scoped=true&"
import script from "./zeroRows.vue?vue&type=script&lang=js&"
export * from "./zeroRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2fa8e",
  null
  
)

export default component.exports